import { isDesktop, isAndroid, isTablet, isIOS } from "react-device-detect";

export function getDeviceType() {
  let deviceType = "Unknown";

  if (isDesktop) {
    deviceType = "Desktop";
  } else if (isAndroid) {
    deviceType = "Android";
  } else if (isTablet && isIOS) {
    deviceType = "iPad";
  } else if (isIOS) {
    deviceType = "iPhone";
  }

  return deviceType;
}
